import { render } from "./SidBarComponent.vue?vue&type=template&id=5700e61e"
import script from "./SidBarComponent.vue?vue&type=script&lang=js"
export * from "./SidBarComponent.vue?vue&type=script&lang=js"

import "./SidBarComponent.vue?vue&type=style&index=0&id=5700e61e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__